import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var FileWord = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 384 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m365.3 93.38-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.006 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6c0-16.9-6.7-33.2-18.7-45.22zM336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160V128c0 17.67 14.33 32 32 32h79.1v288zM214.6 248c-3.3-9.6-12.4-16-22.6-16s-19.25 6.406-22.62 16l-24.68 70.1-25.89-77.66C114.6 227.8 101 221.2 88.41 225.2c-12.58 4.2-19.36 17.8-15.18 30.4l48 144c3.27 9.7 12.27 16.3 22.57 16.4 10.17 0 19.45-6.406 22.83-16L192 328.1l25.4 71.9c3.4 9.6 12.4 16 22.6 16 10.27-.094 19.53-6.688 22.77-16.41l48-144c4.188-12.59-2.594-26.16-15.17-30.38-12.61-4.125-26.2 2.594-30.36 15.19l-25.89 77.66L214.6 248z"
  }));
});
FileWord.displayName = 'FileWord';
export var FileWordDimensions = {
  height: 512,
  width: 384
};